/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Startdate1Inputs */

const en__field_startdate1 = /** @type {(inputs: _Field_Startdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const de__field_startdate1 = /** @type {(inputs: _Field_Startdate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startdatum`)
};

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {_Field_Startdate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_startdate1 = /** @type {((inputs?: _Field_Startdate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Startdate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_startdate1(inputs)
	return de__field_startdate1(inputs)
});
export { _field_startdate1 as "_field_startDate" }